import React, { useMemo, useState } from 'react';
import fetchAPI from '../../utils/fetchAPI';
import UsersInputBoxView from '../view/UsersInputBoxView';

const getUsersPromiseFunction = useEnduserEndpoint => v => {
  const endPoint = useEnduserEndpoint ? '/users/v1/eu/search' : '/users/v1/users';
  const generalURLParams = "offset=0&limit=100&sort='status' asc";
  const queryActiveUsers =
    '[{"field":"\'status\'","op":"=","value":"\'ACTIVE\'"}]';
  const queryFilterMatches = `{"field":"'info'->'email'","op":"ILIKE","value":"%${v}%","internOp":"OR"},{"field":"'info'->'lastName'","op":"ILIKE","value":"%${v}%","internOp":"OR"},{"field":"'info'->'userName'","op":"ILIKE","value":"%${v}%","internOp":"OR"},{"field":"'info'->'firstName'","op":"ILIKE","value":"%${v}%","internOp":"OR"}`;
  const query = `${endPoint}?${generalURLParams}&query=[${queryActiveUsers},${queryFilterMatches}]`;

  return fetchAPI(query).then(({ results }) => {
    const users = results.map(u => ({
      label: `${u.info.firstName} ${u.info.lastName} <${u.info.email}>`,
      value: u.id
    }));

    return users;
  });
};

const UsersInputBoxEngine = ({
  value,
  onChange = v => v,
  customCSS,
  isMulti = true,
  useEnduserEndpoint = false,
  ...props
}) => {
  const [_users, _setUsers] = useState(null);

  const users = useMemo(() => (value ? value : _users), [value, _users]);
  const setUsers = useMemo(() => (onChange ? onChange : _setUsers), [onChange]);

  const viewProps = { 
    getUsersPromise: getUsersPromiseFunction(useEnduserEndpoint),
    isMulti, users, setUsers, customCSS, ...props };

  return <UsersInputBoxView {...viewProps} />;
};

export default UsersInputBoxEngine;
